import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Grid, IconButton, Icon } from '@material-ui/core';
import { LanguageString } from '../../Common';


interface NotificationsDeleteDialogProps {
  open: boolean;
  deleteAll: () => void;
  toggle: () => void;
}

export const NotificationsDeleteDialog: React.FC<NotificationsDeleteDialogProps> = ({open, deleteAll, toggle }) => {
  const handleDeleteAll = () => {
    deleteAll();
    toggle();
  };

  return (
    <Dialog maxWidth="xs" fullWidth scroll="paper" open={open} onClose={toggle}>
      <DialogTitle>
        <Grid container direction="row" justify="space-between">
          <Grid item>
            <LanguageString groupName="GENERAL" resourceName="NOTIFICATIONS_DELETE" defaultText="Delete Notifications" />
          </Grid>
          <Grid item>
            <IconButton edge="start" color="inherit" onClick={toggle} aria-label="close">
              <Icon>close</Icon>
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent id='dialogBox' dividers>
        <Grid container direction="column" justify="center" alignItems='center'>
          <Grid item>
            <LanguageString groupName="General" resourceName='NOTIFICATIONS_DELETE_TEXT' defaultText='Are you sure you want to delete all notifications?' />
          </Grid>
          <Grid item>
            <Button onClick={handleDeleteAll} color="primary" style={{ marginRight: '15px' }}>
              <LanguageString groupName="GENERAL" resourceName="DELETEALL" defaultText="Confirm" />
            </Button>
            <Button onClick={toggle} color="primary">
              <LanguageString groupName="GENERAL" resourceName="CANCEL" defaultText="Cancel" />
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationsDeleteDialog;
